<h4 class="modal-header" ngbAutofocus>ACTIVE CREDENTIALS</h4>
<div class="modal-body">
    <cm-smart-table class="table mb-4" [headers]="TABLE_HEADERS" [rows]="rows"> </cm-smart-table>
    <p class="warning-text">
        If you would like to edit which credentials are associated with this role, please contact your Client Services
        Representative for assistance.
    </p>
</div>
<div class="modal-footer"><button class="btn btn-default" (click)="close()">Close</button></div>
